if (document.querySelector("meta[name='embed'][content='true']")) {
  new window.pym.Child({ polling: 500 })
}
